import { useState, useEffect } from 'react';
import { useDocument } from './useDocument';
const useIsRTL = () => {
    const [isRtl, setIsRtl] = useState(false);
    const [htmlDirIsChecked, setHtmlDirIsChecked] = useState(false);
    const myDocument = useDocument();
    useEffect(() => {
        if (!myDocument) {
            return;
        }
        const html = myDocument.querySelector('html');
        setIsRtl(html.getAttribute('dir') === 'rtl');
        setHtmlDirIsChecked(true);
    }, [myDocument]);
    return { isRtl, htmlDirIsChecked };
};
export default useIsRTL;
